import axios from 'axios'
import { dataGouv } from 'config'

export const dataGouvEnterpriseClient = axios.create({
  baseURL: dataGouv.enterprise_api_url,
  headers: {
    'Content-Type': 'application/json',
  },
})
